import React from 'react'
import '../../App.css'

import {Link} from 'react-router-dom';


export default function Navbar() {
    return (
        <div>
            <nav className="navbar navbar-light" style={{backgroundColor: '#2B2B52', color: '#fff'}}>
                <Link to="/" style={{textDecoration: 'none', color: '#fff'}}><h3 style={{fontFamily: 'Source Sans Pro', fontWeight: 'bold'}}>Lyrico</h3></Link>
            </nav>
        </div>
    )
}